// client/query-shadow-root.ts
function queryAll(selector, rootNode = document.body) {
  const arr = [];
  const traverser = (node) => {
    if (node.nodeType !== Node.ELEMENT_NODE) {
      return;
    }
    if (node.matches(selector)) {
      arr.push(node);
    }
    const children = node.children;
    if (children.length) {
      for (const child of children) {
        traverser(child);
      }
    }
    const shadowRoot = node.shadowRoot;
    if (shadowRoot) {
      const shadowChildren = shadowRoot.children;
      for (const shadowChild of shadowChildren) {
        traverser(shadowChild);
      }
    }
  };
  traverser(rootNode);
  return arr;
}
export {
  queryAll
};
